module.exports = __webpack_public_path__ + "img/tomasbarrios.8167a7b0.jpg";